module.exports = __webpack_public_path__ + "static/media/2.d1779545.jpg";